<template>
  <main-layout>
    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-78"></menubar>
    </div>
    <!--  左メニュー 終了 -->
    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">{{ $t("label.system.link.linkSetting") }}</label>
        <sp-smart-button @click="back" slot="cancel">
          {{ $t("button.common.data.cancel") }}
        </sp-smart-button>
        <narrow-down @click="createLink" slot="create">
          {{ $t("label.popup.system.link.creatLink") }}
        </narrow-down>
      </head-title>
    </el-row>
    <!--  メインページ 開始  -->
    <div slot="body">
      <!-- ヘッダー行 開始 -->
      <div class="m-top-5 m-bottom-5">
        <el-row>
          <el-col :span="24">
            <div class="st-page-size">
              <label class="label lb2 lable-right-16 count">{{ $t("label.common.count") }}</label>
              <el-select v-model="searchResult.pageSize" @change="updateSel">
                <el-option v-for="item in queryNumberList" :key="item.key" :label="item.code" :value="item.key">
                </el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
      </div>
      <!--   検索 終了   -->
      <!--   検索結果 開始   -->
      <div id="popup-link-search-result" class="m-bottom-8" ref="searchResultTable">
        <el-table :data="searchResult.body" style="width: 100%; min-width: 1235px;"
          :default-sort="{prop: 'date', order: 'descending'}">
          <!-- リンク名 -->
          <el-table-column
            prop="linkName"
            class-name="col-5"
          >
            <template slot="header">
              <div>
                <span>{{$t('label.popup.system.link.linkName')}}</span>
                <img src="@/assets/icon/bt_filter_on_off.svg" style="top: 3px; left: 4px; position: relative;" @click="sortData('linkName')">
              </div>
            </template>
          </el-table-column>
          <!-- リンク先 -->
          <el-table-column
            class-name="col-9"
          >
          <template slot="header">
            <div>
              <span>{{$t('label.popup.system.link.link')}}</span>
              <img src="@/assets/icon/bt_filter_on_off.svg" style="top: 3px; left: 4px; position: relative;" @click="sortData('linkType')">
            </div>
          </template>
            <template slot-scope="scope">
              <div v-if="scope.row.linkType == '01'">
                <div class="link-type-style">
                  <div class="link-type-code">
                    {{ $t('label.popup.system.link.InternalLink') }}
                  </div>
                </div>
                <div style="display: inline-block;">
                  {{ scope.row.linkCodeMst }}
                </div>
              </div>
              <div v-if="scope.row.linkType == '02'">
                <div class="link-type-style external">
                  <div class="link-type-code">
                    {{ $t('label.popup.system.link.ExternalLink') }}
                  </div>
                </div>
                <div style="display: inline-block;">
                  <div>
                    {{scope.row.realUrl}}
                  </div>
                </div>
              </div>

            </template>
          </el-table-column>
          <!-- 備考 -->
          <el-table-column
            prop="remark"
            class-name="col-3"
          >
          <template slot="header">
            <div>
              <span>{{$t('label.popup.system.link.remark')}}</span>
              <img src="@/assets/icon/bt_filter_on_off.svg" style="top: 3px; left: 4px; position: relative;" @click="sortData('remark')">
            </div>
          </template>
          </el-table-column>
          <el-table-column align="right">
            <template slot-scope="scope" width="200">
              <div style="min-width: 180px">
                <img v-if="scope.row.linkType == '02'" src="@/assets/icon/icon_link_button.svg" class="m-right-2" style="cursor: pointer;" @click="getUrl(scope.row)">
                <!-- 編集 -->
                <sp-smart-button class="link-btn-edit" @click="editLink(scope.row)">
                  {{ $t('button.common.data.edit') }}
                </sp-smart-button>
                <!-- 削除 -->
                <el-popconfirm
                  popper-class="iot-pop-confirm"
                  :title="$t('message.system.owner.deleteConfirm')"
                  :confirmButtonText="$t('button.common.ok')"
                  :cancelButtonText="$t('button.common.cancel')"
                  class="btn-operate"
                  @onConfirm="deleteLink(scope.row.linkId, scope.$index)"
                >
                  <sp-smart-button slot="reference" class="margin-left-1 ponit-button-delete">
                    {{ $t("button.common.data.delete") }}
                  </sp-smart-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <!--   検索結果 終了   -->

      <!-- ページ 開始  -->
      <pagination
        v-show="pagingShow"
        :totalCount="searchResult.totalCount"
        :totalPage="searchResult.totalPage"
        :pageSize="searchResult.pageSize"
        :pageNumber="searchResult.pageNumber"
        @on-paging="handlePagingAction" />
      <!--  ページ 終了  -->
    </div>
  </main-layout>
</template>

<script>
import SpSmartButton from "@/components/common/sp-smart-button-small"
import NewDesignLayout from "@/layout/NewDesignLayout"
import Pagination from "@/components/common/pagination/Pagination";
import SystemManageApi from "@/api/SystemManageApi";
import Menubar from "@/components/leftmenu/DashBoard"
import headTitle from "@/components/common/head/head"
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import narrowDown from "@/components/common/generalButton/NarrowDown";
const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGE_NUMBER = 1;

export default {
  name: "LinkSetting",
  components: {
    MainLayout: NewDesignLayout,
    SpSmartButton: SpSmartButton,
    Pagination: Pagination,
    Menubar: Menubar,
    narrowDown: narrowDown,
    headTitle: headTitle,
  },
  data() {
    return {
      outlookFlg: false,
      //タイトル表示に使用
      queryNumberList: [
        { key: 10, code: "10件" },
        { key: 20, code: "20件" },
        { key: 50, code: "50件" },
      ],
      linkMstList: [],
      //結果宣言に戻る
      searchResult: {
        pageSize: DEFAULT_PAGE_SIZE,
        pageNumber: DEFAULT_PAGE_NUMBER,
        totalPage: 0,
        totalCount: 0,
        body: [
        ],
      },
      sequence: 'asc',
      orgId: ''
    };
  },
  computed: {
    pagingShow() {
      return this.searchResult.body.length > 0;
    }
  },
  methods: {
    getUrl(row){
      navigator.clipboard.writeText(row.realUrl)
      .then(() => {
        this.$messageIotSuccess(this.$t("message.common.validation.successCopyMessage"))
      })
      .catch(() => {
        this.$messageIotError(this.$t("message.common.error.errorCopyLink"));
      });
    },
    searchLink() {
        this.showTableLoadingAnim();
        SystemManageApi.LinkSearch({ // /system/link/search
          ownerId: this.orgId,
          pageSize: this.searchResult.pageSize,
          pageNumber: this.searchResult.pageNumber,
      })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({data}) => {
          if(!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          this.searchResult.pageSize = data.body.pageSize
          this.searchResult.pageNumber = data.body.pageNumber;
          this.searchResult.totalPage = data.body.totalPage;
          this.searchResult.totalCount = data.body.totalCount;
          this.searchResult.body = [];
          for (let body of data.body.body) {
            if('01' == body.linkType){
              var linkCodeMst = this.spliceLink(body)
            }
            this.searchResult.body.push({
              ownerName: body.ownerName,
              ownerExId: body.ownerExId,
              ownerId: body.ownerId,
              linkId: body.linkId,
              linkName: body.linkName,
              linkType: body.linkType,
              linkCode: body.linkCode,
              linkCodeMst: linkCodeMst,
              detailId: body.detailId,
              detailName: body.detailName,
              realUrl: body.realUrl,
              remark: body.remark,
              linkMstRemark: body.linkMstRemark,
            });
          }
        })
        .finally(() => {
          this.hideTableLoadingAnim();
        });
    },
    searchLinkMst() {
      SystemManageApi.LinkMstGet(
        {
          typeCode: null
        }
      ) // /system/link/mst
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({data}) => {
          if(!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          this.linkMstList = []
          for (let body of data.body) {
            this.linkMstList.push({
              linkCode : body.linkCode,
              linkName : body.linkName,
              linkDescription : body.linkDescription,
              detailEnableFlag : body.detailEnableFlag,
              detailType : body.detailType,
              displayOrder : body.displayOrder,
            })
          }
          this.$nextTick(() => {
            this.searchLink();
          })

        })
    },
    spliceLink(code) {
      let linkNameList = []
      for(let flg = 2; flg < 8;flg+=2){
        this.linkMstList.forEach(element => {
          if(element.linkCode == code.linkCode?.slice(0,flg).padEnd(8, "0")){
            if(!linkNameList.includes(element.linkName)) {
              linkNameList.push(element.linkName)
            }
          }
        });
      }
      if(code.detailName !== undefined && code.detailName !== null){
        if(code.linkCode !== '06010101' && code.linkCode !== '06010102' && code.linkCode !== '09010101'){
          linkNameList.pop();
        }
        linkNameList.push(code.detailName)
      }
      return linkNameList.join('>')
    },
    //show anim
    showTableLoadingAnim() {
      if (this.tableLoadingAnim == null) {
        this.tableLoadingAnim = this.$loading({
          target: "#popup-link-search-result",
          background: "#ebebe6"
        });
      }
    },

    //hide anim
    hideTableLoadingAnim() {
      if (this.tableLoadingAnim != null) {
        this.tableLoadingAnim.close();
        this.tableLoadingAnim = null;
      }
    },
    back() {
      this.$router.push({
        name: "system-owner-setting-edit",
        query: {
          orgId: this.orgId,
          ownerDetail: JSON.stringify(this.ownerDetail)
        }
      })
    },
    createLink () {
      this.$router.push({
        name: "link-create", // M-12-05
        query: {
          orgId: this.orgId,
          ownerDetail: JSON.stringify(this.ownerDetail),
          type: '01'
        }
      });
    },

    editLink(row) {
      this.$router.push({
        name: "link-create", // M-12-05
        query: {
          orgId: this.orgId,
          linkId: row.linkId,
          type: '01',
          ownerDetail: JSON.stringify(this.ownerDetail),
        }
      });
    },

    //削除バータン
    deleteLink(linkId, index) {
      SystemManageApi.LinkDelete(linkId) // /system/link/{link_id}
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          let linklist = this.searchResult.body;
          linklist.splice(index, 1);
          this.deleteSuccess();
        })
        .finally(() => {
          this.searchLink();
        });
    },

    deleteSuccess(){
      this.$messageIotSuccess(this.$t("message.common.deleteSuccess",{
        field: this.$t("label.system.link.title")
      }));
    },

    sortData(key){
      if (this.sequence === 'asc') {
          this.searchResult.body.sort((a, b) => {return String(a[key]).localeCompare(String(b[key]), 'ja-JP-u-ca-japanese-kf-upper')});
          this.sequence = 'desc'
      } else {
          this.searchResult.body.sort((a, b) => {return String(b[key]).localeCompare(String(a[key]), 'ja-JP-u-ca-japanese-kf-upper')});
          this.sequence = 'asc'
      }
    },
    updateSel() {
      this.searchResult.pageNumber = 1
      this.searchLink();
      this.$forceUpdate();
    },
    handlePagingAction(paging) {
      this.searchResult.pageSize   = paging.pageSize
      this.searchResult.pageNumber = paging.pageNumber
      this.searchLink()
      this.$refs.searchResultTable.scrollIntoView()
    },
  },
  created() {
    this.orgId = this.$route.query.ownerId
    this.ownerDetail = JSON.parse(this.$route.query.ownerDetail)
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/owners/search",
        title: "label.router.owner",
      },
      {
        path: "",
        title: "label.system.link.linkSetting",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);

  },
  mounted() {
    this.searchLinkMst()
    // this.searchLink();
  },
};

</script>

<style scoped lang="scss">
.btn-operate {
  margin: 0 5px 0 0;
}
.btn-operate-other {
  margin-left: 5px;
}
 .st-page-size label {
   top: 0px;
   left: 0px;
 }

 .float-left {
   float: left;
 }

 .point-title{
  top: 10px!important;
  font-family: Hiragino Kaku Gothic Pro, sans-serif;
  font-size: 20px;
  font-weight: 300;
  line-height: 30px;
  text-align: left;
 }

.count {
  font-family: Hiragino Kaku Gothic Pro, sans-serif;
  font-size: 12px;
  font-weight: 300;
  line-height: 18px;
  text-align: left;
}

.point-search {
  display: inline-block;
  margin-left: 4px;
  width: 324px;
  height: 44px;
  padding: 8px 10px 8px 12px;
  border-radius: 8px 0px 0px 0px;

  ::v-deep.el-input__prefix{
    left: 20px;
    top: 12px;
  }
}
 ::v-deep .cancel-width{
  .my-button{
    height: 32px;
    width: 152px;
  }
}
//  No.50
 .my-button{
   padding: 0px;
   height: 32px !important;
 }
// ::v-deep .create {
//   padding-right: 24px;
// }

.link-btn-edit {
  width: 52px !important;
  margin: 0 12px!important;
  padding: 0 !important;
}
.ponit-button-distribute {
  width: 104px;
  margin-right: 8px;
}
.ponit-button-delete {
  width: 52px !important;
  padding: 0 !important;
}
.link-type-style {
  display: inline-block;
  width: 71px;
  height: 25px;
  padding: 6px 8px;
  margin-right: 8px;
  background: #DEDED1;
  .link-type-code {
    font-family: Hiragino Kaku Gothic Pro;
    font-size: 11px;
    font-weight: 300;
    line-height: 16.5px;
    text-align: left;
    color: #6B6B69;
  }
}
.external {
  background: #ABDBDF;
}
</style>
